"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        avatar: function (_a) {
            var width = _a.width, borderRadius = _a.borderRadius;
            return ({
                border: '3px solid #ffffff',
                borderRadius: !borderRadius ? '50%' : borderRadius,
                width: !width ? '100%' : width,
            });
        },
    });
});
